<template>
    <div class="details-container" :class="{ 'show-comments': show }">
        <!-- Header -->
        <div class="header">
            <div class="inner-color">
                <img @click="back" class="back" :src="Back" alt="Back">  
                <h6 class="video-title">{{ response.Title }}</h6>

                <!-- Banner -->
                <div class="banner">
                    <img id="playBTN" class="play-btn" @click="play" :src="PlayBtn" alt="play">
                    <span id="fullBTN" class="btn btn-light btn-full" @click="fullscreen" >
                        <i class="far fa-compress-wide"></i>
                    </span>
                    <video id="video" class="banner-inner" @click="pause">
                        <source
                            v-if="response.File"
                            :src="URL + '/' + response.File" 
                            type="video/mp4"
                        >
                        Your browser does not support the video tag.
                    </video>
                        
                    <div class="progress" style="direction: ltr">>
                        <progress id="progress" :value="value" min="0">
                            <span id="progress-bar"></span>
                        </progress>
                        <input type="range" id="bar" min="0" max="1" step="0.01" :value="value">
                    </div>
                </div>

                <div class="container">
                    <div class="row">
                        <div class="col-6">
                            <p>{{ response.Desc }}</p>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-light btn-comment" @click="CommentPopUp">افزودن نظر</button>
                            <button class="btn btn-light" :class="{ 'show-btns': show }" @click="() => { show = !show }">نظر دیگران</button>
                        </div>
                    </div>
                </div>

                <fullscreen :fullscreen.sync="showFS" class="fullscreen">
                    <a class="close-btn" @click="closeFull">
                        <i class="far fa-times" aria-hidden="true"></i>
                    </a>
                    <video 
                        id="videoFull" class="video-inner"
                        v-if="showFS"
                        controls
                        controlsList="nodownload"
                        autoplay
                    >
                        <source
                            v-if="response.File"
                            :src="URL + '/' + response.File" 
                            type="video/mp4"
                        >
                        Your browser does not support the video tag.
                    </video>
                </fullscreen>
            </div>
        </div>

        <!-- Details -->
        <template v-if="!show">
            <img class="shining-arrow" :src="ShiningArrow" alt="ShiningArrow">
        </template>
        <div v-else class="comment-part">
            <template
                v-for="(c, index) in response.Comments"
            >
                <!-- Comment -->
                <div class="comment" :key="index + '-comment'" v-if="!c.isRemoved">
                    <div class="profile-container"
                        
                        :style="{ 'background-image': 'url(' + ProfileBG + ')' }"
                    >
                        <div class="profile-pic"
                            :style="{ 'background-image': 'url(' + URL + '/' + (c.CommentOwner || {}).ProfilePic + ')' }"
                        ></div>
                    </div>
                    <p class="title">{{ (c.CommentOwner || {}).FirstName + ' ' + (c.CommentOwner || {}).LastName }} نوشته:</p>
                    <p class="body">{{ c.Text }}</p>
                </div>
                <!-- Answer -->
                <div class="comment-answer" :key="index + '-answer'" v-if="c.Answer && !c.isRemoved">
                    <p class="title">در جواب «{{ (c.CommentOwner || {}).FirstName + ' ' + (c.CommentOwner || {}).LastName }}» نوشته:</p>
                    <p class="body">{{ c.Answer }}</p>
                </div>
            </template>
        </div>

        <!-- Modals -->
        <comment-modal :AddComment="AddComment"/>
    </div>
</template>

<script>
import ProfileBG from '@/assets/images/courses/profile-bg.png';
import Back from '@/assets/images/courses/video-details/back.png';
import ShiningArrow from '@/assets/images/courses/video-details/shining-arrow.png';
import PlayBtn from '@/assets/images/btn-play.png';

import { getRequest, postRequest, APP_API_URL } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

import CommentModal from '@/components/modals/comment_modal';

export default {
    name: 'BaseCourseDetails',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    data() {
        return {
            send: false,
            time: false,

            value: 0,
            Back: Back,
            PlayBtn: PlayBtn,
            ShiningArrow: ShiningArrow,

            ProfileBG: ProfileBG,

            prevRoute: {},
            show: false,
            showFS: false,

            response: {},
            URL: APP_API_URL(),

            courseId: this.$route.params.course,
            videoId: this.$route.params.id,

            videoTime: 0
        }
    },
    components: {
        CommentModal,
    },
    mounted() {
        this.getCurrent();

        let video = document.getElementById('video');
        let Bar = document.getElementById('bar');

        video.addEventListener('timeupdate', () => {
            this.value = (video.currentTime / video.duration);

            if(video.duration - video.currentTime < 10) {
                this.addViewr();
            }

            if(video.currentTime.toFixed() % 10 == 0) {
                if(this.time) return;
                else this.time = true;

                if((Cookies.get(this.videoId) || 0) < video.currentTime) {
                    Cookies.set(this.videoId, video.currentTime / video.duration)
                }

                setTimeout(() => {
                    this.time = false;
                }, 2000)
            }
        }, false);

        video.addEventListener('contextmenu', e => e.preventDefault());


        Bar.addEventListener('change', () => {
            // Update the video volume
            video.currentTime = Bar.value * video.duration;
        });
    },
    methods: {
        addViewr() {
            if(this.send) return;
            else this.send = true;

            Cookies.remove(this.videoId)   
            postRequest('/base-courses/add-viewer', {
                id: this.courseId,
                videoId: this.videoId
            })
                .then(() => {
                })
                .catch(err => {
                // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        }
                    }
                })
                .finally(() => {
                    this.send = false;
                });
        },

        CommentPopUp() {
            this.$modal.show('comment-modal');
        },
        AddComment(text) {
            postRequest('/base-courses/add-comment', {
                id: this.courseId,
                videoId: this.videoId,
                text: text
            })
                .then(() => {
                    this.getCurrent()
                })
                .catch(err => {
                // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        }
                    }
                });
        },
        play() {
            let video = document.getElementById('video');
            let btn = document.getElementById('playBTN');
            let full = document.getElementById('fullBTN');
            
            btn.style.display = 'none';
            full.style.display = 'inline-block';

            video.play();
            video.addEventListener('ended', () => {
                video.currentTime = 0;
                btn.style.display = 'inline-block';
            }, false);

        },
        fullscreen() {
            let video = document.getElementById('video');
            let btn = document.getElementById('playBTN');
            let full = document.getElementById('fullBTN');
            
            video.pause();
            
            full.style.display = 'none';
            btn.style.display = 'inline-block';

            this.showFS = !this.showFS;

            setTimeout((() => {
                this.videoTime = video.currentTime;

                let videoFull = document.getElementById('videoFull');
                videoFull.currentTime = this.videoTime;
                videoFull.addEventListener('contextmenu', e => e.preventDefault());

                videoFull.pause();
            }).bind(this), 0)
        },
        closeFull() {
            let video = document.getElementById('video');
            let videoFull = document.getElementById('videoFull');
            videoFull.addEventListener('contextmenu', e => e.preventDefault());

            this.videoTime = videoFull.currentTime;
            video.currentTime = this.videoTime;

            this.showFS = false;
        },
        pause() {
            let video = document.getElementById('video');
            let btn = document.getElementById('playBTN');
            let full = document.getElementById('fullBTN');

            video.pause();
            full.style.display = 'none';
            btn.style.display = 'inline-block';
        },
        getCurrent() {
            getRequest('/base-courses/find-one', { id: this.courseId })
                .then((rsp) => {
                    let data = rsp['data'].course

                    data['Videos'].forEach(v => {
                        if(v._id == this.videoId) {
                            this.response = v;
                        }
                    });
                })
                .catch(err => {
                // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        }
                    }
                });
        },
        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        }
    }
}
</script>

<style scoped>
.details-container .progress {
    cursor:pointer;
    position: relative;
    top: -20px;
    padding: 2px 15px;

    overflow: visible;
    background-color: transparent;
}
.details-container .progress #progress {
    width: 100%;
}
.details-container #bar {
    width: calc(100% - 26px);

    position: absolute;
    top: 0px;
    right: 13px;
}


/* ---------------------------------------- */
/* ---------------- GENERAL --------------- */
/* ---------------------------------------- */
.details-container.show-comments {
    background-color: #373b48;
}
.details-container .show-btns {
    box-shadow: inset 1px 2px 5px 2px #cccccc82 !important;
    background-color: #f7f7f7 !important;
}
.details-container .header .btn-comment {
    margin-left: 5pt;
}
/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.details-container {
    min-height: 100vh;
    background-color: #f1f2f6;

    position: relative;
    overflow: hidden;
} 
.details-container .header {
    height: 60vh;
    width: 100vw;

    position: relative;
    overflow: hidden;

    color: #666;
}
.details-container .header .back {
    height: 5vh;

    position: absolute;
    top: 10pt;
    right: 10pt;

    cursor: pointer;
}
.details-container .header .video-title {
    position: absolute;
    top: calc(5pt + 1rem);
    right: 35pt;
}
.details-container .header .btn-full {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 11;

    padding: .375rem;
    line-height: 1;
    display: none;
}
.details-container .header .inner-color {
    height: 100%;
    width: 100%;
    padding: 45pt 15pt;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #fff;

    border-bottom-left-radius: 50pt;
}
.details-container .header .col-6 {
    height: auto;
    padding: .125rem;
    padding-top: 15pt;

    display: flex;
}
.details-container .header p,
.details-container .header button {
    width: 95%;
    max-width: 200pt;
    margin: 0 auto auto;

    font-size: 1rem;
    text-align: center;
}
.details-container .header button {
    height: 35pt;
    border-radius: 17pt;
    border: 1pt solid #ddd;
    box-shadow: 2px 3px 5px 0 #ddd;
}
@media (max-width: 576px) {
    .details-container .header .video-title {
        top: calc(5pt + .75rem);
    }
    .details-container .header p,
    .details-container .header button {
        font-size: .5rem;
    }
}

/* ---------------------------------------- */
/* ------------- VIDEO BANNER ------------- */
/* ---------------------------------------- */
.details-container .header .banner {
    height: 30vh;
    width: 85%;
        
    margin: auto;
    margin-top: 5vh;
    padding: 5pt;

    position: relative;

    border: 2px solid #fff;
    border-radius: 20pt;
    background-color: #ebecf1;
    box-shadow: inset 2.2px 2.2px 4px #c3c5c7;
}
.details-container .header .banner .play-btn {
    height: 35pt;
    width: 35pt;

    position: absolute;
    top: calc(15vh - 20pt);
    left: calc(50% - 15pt);
    z-index: 4;

    cursor: pointer;
}
.details-container .header .banner .banner-inner {
    height: 100%;
    width: 100%;

    position: relative;
    display: flex;
    flex-direction: column;

    border-radius: 15pt;
    background-color: #000;
}
@media (max-width: 576px) {
    .details-container .header .banner {
        margin-top: 0;
    }
}

/* ---------------------------------------- */
/* ------------- VIDEO DETAILS ------------ */
/* ---------------------------------------- */
.details-container .blue-box {
    height: 50vh;

    position: absolute;
    bottom: -10vh;
    left: -10vh;
}
.details-container .shining-arrow {
    height: 40vh;

    position: absolute;
    bottom: -10pt;
    right: 10pt;
}

/* ---------------------------------------- */
/* ------------- VIDEO DETAILS ------------ */
/* ---------------------------------------- */
.details-container .comment-part {
    height: 40vh;
    width: 100%;

    padding: 20pt 15pt;

    overflow: scroll;
}
.details-container .comment-part .comment-answer,
.details-container .comment-part .comment {
    margin-bottom: 10pt;
    padding: 10pt 10pt 5pt;

    border-radius: 15pt;
    background-color: #4d5262;
}
.details-container .comment-part .comment-answer {
    background-color: #7e6f33;
    margin-right: 15pt;
}
.details-container .comment-part .comment .profile-container {
    height: 45pt;
    width: 45pt;
    border-radius: 25pt;

    float: right;
    margin-left: 10pt;

    display: flex;

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.details-container .comment-part .comment .profile-pic {
    height: calc(100% - 8pt);
    width: calc(100% - 8pt);
    margin: auto;
    border-radius: 25pt;

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.details-container .comment-part .comment-answer .title,
.details-container .comment-part .comment .title {
    color: #fff;
    font-weight: bold;
}
.details-container .comment-part .comment-answer .body,
.details-container .comment-part .comment .body {
    color: #bbbbbc;
}

@media (max-width: 576px) {
    .details-container .comment-part .comment-answer .title,
    .details-container .comment-part .comment-answer .body,
    .details-container .comment-part .comment .title,
    .details-container .comment-part .comment .body {
        font-size: 85%;
    }
}

/* ---------------------------------------- */
/* -------------- FULL SCREEN ------------- */
/* ---------------------------------------- */
.fullscreen {
    display: flex;
    position: relative;
    color: #fff;
}
.fullscreen .close-btn {
  position: absolute;
  top: 5pt;
  right: 10pt;
  z-index: 1;

  font-size: 2rem;
  cursor: pointer;
}
.fullscreen .video-inner{
    height: 100%;
    width: 100%;
    margin: auto;
    background-color: #000;
}
</style>